module.exports = __webpack_public_path__ + "img/shouhui1.44ee35ed.png";